import { ComponentPropsWithoutRef, ReactNode } from 'react';
import NavbarBrand from './NavbarBrand';
import NavbarCollapse from './NavbarCollapse';
import NavbarToggler from './NavbarToggler';

interface NavbarProps extends ComponentPropsWithoutRef<'nav'> {
  children: ReactNode;
  theme?: string;
}

const Navbar = ({ children, theme = 'light', ...props }: NavbarProps) => (
  <nav className={`navbar navbar-expand-lg navbar-${theme}`} {...props}>
    {children}
  </nav>
);

Navbar.Brand = NavbarBrand;
Navbar.Collapse = NavbarCollapse;
Navbar.Toggler = NavbarToggler;

export default Navbar;
